import TextField from '@mui/material/TextField'
import styled from 'styled-components'

export const Input = styled(TextField)`
  && {
  }
`
